import { Controller } from "@hotwired/stimulus"

// CPD regenerate wizard — companion to the generic v2-stepper.
// Validates each step, toggles the time-window inputs based on the selected
// time_filter, and writes summaries.
export default class extends Controller {
  static targets = [
    "destinationCheckbox",
    "timeFilterRadio",
    "timeWindow",
  ]

  static outlets = ["v2-stepper"]

  connect() {
    this._syncTimeWindowVisibility()
  }

  timeFilterChanged() {
    this._syncTimeWindowVisibility()
  }

  dateChanged(event) {
    this._dateFrom = event.detail.from
    this._dateTo = event.detail.to
  }

  validate(event) {
    const step = event.detail.step
    let valid = true

    switch (step) {
      case 1:
        valid = this.destinationCheckboxTargets.some((cb) => cb.checked)
        break
      case 2: {
        const selected = this._selectedFilter()
        if (selected && selected !== "none") {
          const [from, to] = this._currentRange()
          valid = !!from && !!to
        }
        break
      }
    }

    if (!valid) event.preventDefault()
  }

  stepChanged(event) {
    const stepper = this.v2StepperOutlet
    if (!stepper) return
    for (let i = 1; i < event.detail.step; i++) {
      stepper.setSummary(i, this.summaryForStep(i))
    }
  }

  summaryForStep(step) {
    switch (step) {
      case 1: {
        const total = this.destinationCheckboxTargets.length
        const count = this.destinationCheckboxTargets.filter((cb) => cb.checked).length
        if (count === total) return `All ${total} destinations`
        return `${count} of ${total} destinations`
      }
      case 2: {
        const selected = this._selectedFilter()
        if (!selected || selected === "none") return "Default source lookback"
        const [from, to] = this._currentRange()
        return `${selected}: ${from || "?"} to ${to || "?"}`
      }
      default:
        return ""
    }
  }

  _syncTimeWindowVisibility() {
    const selected = this._selectedFilter()
    const scoped = selected && selected !== "none"
    if (!this.hasTimeWindowTarget) return
    if (scoped) {
      this.timeWindowTarget.classList.remove("hidden")
    } else {
      this.timeWindowTarget.classList.add("hidden")
    }
  }

  _selectedFilter() {
    const selected = this.timeFilterRadioTargets.find((r) => r.checked)
    return selected ? selected.value : null
  }

  _currentRange() {
    const form = this.element.closest("form")
    const from = form?.querySelector('input[name="cpd_management_regenerate_request[time_start]"]')?.value
    const to = form?.querySelector('input[name="cpd_management_regenerate_request[time_end]"]')?.value
    return [from, to]
  }
}
